<div class="modal-header">
    <h4 class="modal-title">MPIN</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="close(false)"></button>
</div>
<div class="modal-body" style="place-self:center">
    <div class="row">
        <div class="col-8">
            <span class="px-1" style="font-size: 0.9rem;">Enable MPIN</span>
        </div>
        <div class="col-4" style="justify-items:right">
            <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked"
                    [ngModel]="data.IsMPINEnabled" (change)="onSwitchChange($event)">
            </div>
        </div>
    </div>
    <hr/>
    <div class="input-group input-group" [ngClass]="{'colHide': !data.IsMPINEnabled}">
        <ng-otp-input class="mx-1" (allowNumbersOnly)=true (onInputChange)="onMpinChange($event)" [ngModel]="data.MPIN"
            #MPIN="ngModel" name="MPIN" [config]="{length:4,allowNumbersOnly:true,isPasswordInput:!showMPIN}"
            ngDefaultControl></ng-otp-input>
        <div class="input-group-text bg-white" (click)="toggleMPINVisibility(1)"><i class="bi bi"
                [ngClass]="{'bi-eye': !showMPIN,'bi-eye-slash': showMPIN}"></i>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" [disabled]="isDisabled"
        (click)="Mobile_ESS_Update_LocalAuthUpdate()"><i class="bi bi-check" *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?'Update':'Loading...'}}</button>

    <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled" (click)="close(false)"><i
            class="bi bi-x" *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?'Close':'Loading...'}}</button>
</div>